var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116 116",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    fillOpacity: 0.984,
    d: "M 24.5,19.5 C 46.5025,19.3334 68.5025,19.5 90.5,20C 104.557,19.0621 112.057,25.5621 113,39.5C 113.667,52.1667 113.667,64.8333 113,77.5C 112.221,92.9339 104.055,99.7672 88.5,98C 64.4753,98.8921 40.4753,98.5587 16.5,97C 6.01105,94.8298 1.17772,88.3298 2,77.5C 1.12715,62.7968 1.46049,48.1301 3,33.5C 3.50821,28.9881 5.67487,25.4881 9.5,23C 14.4993,21.2923 19.4993,20.1256 24.5,19.5 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff8181",
    d: "M 47.5,43.5 C 46.1667,53.8333 46.1667,64.1667 47.5,74.5C 47.44,75.0431 47.1067,75.3764 46.5,75.5C 45.1667,64.5 45.1667,53.5 46.5,42.5C 47.1067,42.6236 47.44,42.9569 47.5,43.5 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fffbfb",
    d: "M 47.5,43.5 C 56.7988,48.1493 65.7988,53.316 74.5,59C 65.7988,64.684 56.7988,69.8507 47.5,74.5C 46.1667,64.1667 46.1667,53.8333 47.5,43.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.388973dec623fa7605a05ae22d685fa5.svg";
export { ForwardRef as ReactComponent };